import Alpine from "alpinejs";
import Swiper from "swiper";
import { Scrollbar } from "swiper/modules";

Alpine.data("swiper", (maxSlides, shuffle = false) => ({
    options: {
        modules: [Scrollbar],
        scrollbar: {
            el: ".js-edgeslider-scrollbar",
            draggable: true,
        },
        slidesPerView: "auto",
        spaceBetween: 10,
        breakpoints: {
            0: {
                slidesPerView: 1,
            },
            375: {
                slidesPerView: Math.max(1.1, (375 / 1184) * maxSlides),
            },
            475: {
                slidesPerView: Math.max(1.1, (475 / 1184) * maxSlides),
                spaceBetween: 16,
            },
            640: {
                slidesPerView: Math.max(1.1, (640 / 1184) * maxSlides),
                spaceBetween: 24,
            },
            768: {
                slidesPerView: Math.max(1.1, (768 / 1184) * maxSlides),
            },
            860: {
                slidesPerView: Math.max(1.1, (860 / 1184) * maxSlides),
            },
            1024: {
                slidesPerView: Math.max(1.1, (1024 / 1184) * maxSlides),
            },
            1184: {
                slidesPerView: maxSlides,
                spaceBetween: 32,
            },
        },
    },
    init() {
        if (shuffle) {
            this.$el
                .querySelector(".swiper-wrapper")
                .replaceChildren(
                    ...[...this.$el.querySelector(".swiper-wrapper").children].sort(() => Math.random() - 0.5)
                );
        }
        this.$nextTick(() => {
            new Swiper(this.$el, this.options);
        });
    },
}));
